import React from 'react'
import { Image } from 'react-bootstrap'
import { Link } from 'react-router-dom'

const IncidentHeader = () => {
  return (
    <>
      <div className="commitee-header">
        <h1>Add Incident</h1>

      </div>
    </>
  )
}

export default IncidentHeader
